module.exports = __webpack_public_path__ + "static/media/PaddingAllsidesblue.bc9a4836.svg";